import StationPlaceRecentEvents from './StationPlaceRecentEvents';

export default StationPlaceRecentEvents;
